import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../spacesPlatform/utils/actionParams';


export interface IChangeExtractToLiveActionOnDatasourcesParams extends IMultipleIdsParams {
  workbookId: string;
}

export class ChangeExtractToLiveActionOnDatasourcesRequest extends Request<IChangeExtractToLiveActionOnDatasourcesParams, IResult> {
  constructor(dataSourceIds: string[], workbookId: string) {
    super('changeExtractToLiveActionOnDatasources', {
      ids: dataSourceIds,
      workbookId: workbookId
    });
  }
}
